<template>
  <ChallengeForm />
</template>

<script>
import ChallengeForm from '../components/ChallengesForm.vue'

export default {
  components: { ChallengeForm },
}
</script>
